export default {
    name: 'QBreadcrumb',
    props: {
        stack: []
    },
    methods: {
        changeView: function(view) {
            this.$routingBus.$emit('changeView', view);
        }
    }
};
